import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from '@ibc/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// Integración final en `main.ts`
bootstrapApplication(AppComponent, {
  providers: appConfig.providers,
}).catch(err => console.error(err));
